import React, { useEffect, useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import Select from "react-tailwindcss-select";
import { FaCalendarAlt } from "react-icons/fa";
import OneWayForPhone from "components/OneWayForPhone/OneWayForPhone";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import userResources from "api/userResources";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function OneWay() {
  const navigate = useNavigate();
  const [airpotsFrom, setAirpotsFrom] = useState(null);
  const [airpotsTo, setAirpotsTo] = useState(null);
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [infants, setInfants] = useState(0);
  const [selectedFlightType, setSelectedFlightType] = useState("economy");
  const [phoneNumber, setPhoneNumber] = useState();
  const [airport, setAirport] = useState([]);
  const [airportSearch, setAirportSearch] = useState();
  const [directFlight, setDirectFlight] = useState(true);
  const [loading, setLoading] = useState(false);
  const [depart, setDepart] = useState({
    startDate: new Date(),
    endDate: new Date().setMonth(11),
  });
  const [returnFlight, setReturnFlight] = useState({
    startDate: new Date(),
    endDate: new Date().setMonth(11),
  });
  const handleFlightTypeChange = (event) => {
    setSelectedFlightType(event.target.value);
  };
  const handleDirectflight = (event) => {
    setDirectFlight(event.target.checked);
  };
  const From = (value) => {
    setAirpotsFrom(value);
  };

  const To = (value) => {
    setAirpotsTo(value);
  };

  const departFun = (newValue) => {
    setDepart(newValue);
  };

  const setReturnFlightFun = (newValue) => {
    setReturnFlight(newValue);
  };

  const getAirport = async (filter) => {
    const params = {
      iata: filter,
    };
    try {
      const res = await userResources.airport(params);
      const data = res.data.data.map((item) => ({
        value: item?.id,
        label: item?.iata + " " + item?.name,
      }));
      setAirport(data);
    } catch (error) {
      console.error("Failed to fetch airport data:", error);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const data = {
      form_world_airport_id: airpotsFrom?.value,
      to_world_airport_id: airpotsTo?.value,
      departure_date: depart?.startDate,
      // return_date omitted for one-way
      adults: parseInt(adults),
      children: parseInt(children),
      infants: parseInt(infants),
      travel_type: selectedFlightType,
      phone: phoneNumber,
      direct_flight: directFlight,
    };

    try {
      await userResources.submitSearchEnquiry(data);
      // navigate to loading screen with form data
      navigate("/loading", {
        state: {
          fromLabel: airpotsFrom?.label,
          toLabel: airpotsTo?.label,
          departure_date: depart?.startDate,
          adults: parseInt(adults),
          children: parseInt(children),
          infants: parseInt(infants),
          travel_type: selectedFlightType,
          phone: phoneNumber,
          direct_flight: directFlight,
        },
      });
    } catch (err) {
      toast.error(
        "❌ Submission failed. Please try again or call us at 905-244-1300."
      );
    }
  };

  useEffect(() => {
    if (airportSearch) {
      getAirport(airportSearch);
    }
  }, [airportSearch]);
  return (
    <section className="mb-0 max-w-full px-5 py-2 sm:mb-5 ">
      <form onSubmit={onSubmit} className="hidden sm:block">
        <div className="flex flex-wrap rounded-md border border-gray-700 py-5">
          <div className="flex w-1/5 flex-col border-r border-gray-700 px-3">
            <label className="text-md ">FROM</label>
            <Select
              value={airpotsFrom}
              onChange={From}
              options={airport}
              isSearchable={true}
              onSearchInputChange={(e) => {
                setAirportSearch(e.target.value);
              }}
              loading={false}
              classNames={{
                menuButton: ({ isDisabled }) =>
                  `flex  w-full cursor-pointer relative -left-3 border-0 text-lg overflow-hidden text-gray-900 transition-all outline-none duration-300 focus:outline-none cursor-pointer ${
                    isDisabled
                      ? "bg-gray-200 "
                      : "bg-white hover:border-gray-400 cursor-pointer"
                  }`,
                menu: "absolute z-10 w-full bg-white shadow-lg border rounded py-1 mt-1.5 text-sm text-gray-700",
                listItem: ({ isSelected }) =>
                  `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded ${
                    isSelected
                      ? `text-white bg-blue-500`
                      : `text-gray-500 hover:bg-blue-100 hover:text-blue-500`
                  }`,
              }}
              formatGroupLabel={(data) => (
                <div
                  className={`flex items-center justify-between py-2 text-xs`}
                >
                  <span className="font-bold">{data.label}</span>
                  <span className="flex  h-5 items-center justify-center rounded-full bg-gray-200 p-1.5">
                    {data.options.length}
                    👉 Airpots
                  </span>
                </div>
              )}
              formatOptionLabel={(data) => (
                <li
                  className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                    !data.isSelected
                      ? `bg-gray-200 text-gray-900`
                      : `bg-blue-800 text-gray-200`
                  }`}
                >
                  {data.label}
                </li>
              )}
            />
          </div>
          <div className="flex w-1/5 flex-col border-r border-gray-700 px-3">
            <label className="text-md ">To</label>

            <Select
              value={airpotsTo}
              onChange={To}
              options={airport}
              isSearchable={true}
              onSearchInputChange={(e) => {
                setAirportSearch(e.target.value);
              }}
              loading={false}
              classNames={{
                menuButton: ({ isDisabled }) =>
                  `flex  w-full cursor-pointer  relative -left-3 border-0 text-lg overflow-hidden text-gray-900 transition-all outline-none duration-300 focus:outline-none cursor-pointer ${
                    isDisabled
                      ? "bg-gray-200"
                      : "bg-white hover:border-gray-400"
                  }`,
                menu: "absolute z-10 w-full bg-white shadow-lg border rounded py-1 mt-1.5 text-sm text-gray-700",
                listItem: ({ isSelected }) =>
                  `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded ${
                    isSelected
                      ? `text-white bg-blue-500`
                      : `text-gray-500 hover:bg-blue-100 hover:text-blue-500`
                  }`,
              }}
              formatGroupLabel={(data) => (
                <div
                  className={`flex items-center justify-between py-2 text-xs`}
                >
                  <span className="font-bold">{data.label}</span>
                  <span className="flex  h-5 items-center justify-center rounded-full bg-gray-200 p-1.5">
                    {data.options.length}
                    👉 Airpots
                  </span>
                </div>
              )}
              formatOptionLabel={(data) => (
                <li
                  className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                    !data.isSelected
                      ? `bg-gray-200 text-gray-900`
                      : `bg-blue-800 text-gray-200`
                  }`}
                >
                  {/* // data represents each option in the list */}
                  {data.label}
                </li>
              )}
            />
          </div>

          <div className="w-1/5 border-r border-gray-700 px-3">
            <div className="flex items-center gap-2">
              <FaCalendarAlt />
              <label className="text-md">DEPART</label>
            </div>
            <Datepicker
              containerClassName="relative"
              inputClassName="w-full p-2 bg-white text-black  outline-none"
              toggleClassName="absolute z-50 right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-blue-500"
              popoverDirection="down"
              useRange={false}
              asSingle={true}
              value={depart}
              showShortcuts={false}
              onChange={departFun}
            />
          </div>
          <div className="w-1/5 cursor-not-allowed border-r border-gray-700 px-3 text-gray-400">
            <div className="flex cursor-not-allowed items-center gap-2">
              <FaCalendarAlt />
              <label className="text-md cursor-not-allowed">RETURN</label>
            </div>
            <Datepicker
              containerClassName=""
              inputClassName="p-0 pt-2 w-1/2 bg-white outline-0 text-gray-200 z-50 cursor-not-allowed"
              toggleClassName="relative w-2/1 float-right cursor-not-allowed"
              popoverDirection="up"
              useRange={false}
              asSingle={true}
              // value={returnFlight}
              showShortcuts={true}
              disabled={true}
              // disabledDates={[
              //   {
              //     startDate: "2024-03-04",
              //     endDate: "2023-02-05",
              //   },
              //   {
              //     startDate: "2024-04-05",
              //     endDate: "2023-02-12",
              //   },
              // ]}
              onChange={setReturnFlightFun}
            />
          </div>
          <div className="w-1/5  px-3">
            <div className="flex items-center gap-2">
              <FaCalendarAlt />
              <label className="text-md">TRAVELLERS</label>
            </div>
            <div className=" dropdown w-full">
              <div tabIndex={0} role="button" className="cursor-pointer">
                <h3 className="text-lg">
                  {adults + children + infants} Travellers
                </h3>
                <p className="text-sm">
                  {selectedFlightType === "economy"
                    ? "Economy"
                    : selectedFlightType === "premium_economy"
                    ? "Premium Economy"
                    : selectedFlightType === "business"
                    ? "Business"
                    : ""}
                </p>
              </div>
              <div
                tabIndex={0}
                className="menu dropdown-content z-[1] w-52 rounded-box bg-white p-2 shadow"
              >
                <div className="cursor-pointer rounded-md border-b p-2 hover:bg-gray-100">
                  <div className="flex items-center justify-between">
                    <h4>Adults</h4>
                    <h4>{adults}</h4>
                    <div className="flex items-center rounded-md border">
                      <div
                        className="cursor-pointer border border-r-0 p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => {
                          if (adults > 1) {
                            setAdults(adults - 1);
                          }
                        }}
                      >
                        -
                      </div>
                      <div
                        className="border-s-0 cursor-pointer border p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => setAdults(adults + 1)}
                      >
                        +
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cursor-pointer rounded-md border-b p-2 hover:bg-gray-100">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4>Children</h4>
                      <h6 className=" text-gray-400">2-12 Years</h6>
                    </div>
                    <h4>{children}</h4>
                    <div className="flex items-center rounded-md border">
                      <div
                        className="cursor-pointer border border-r-0 p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => {
                          if (children > 0) {
                            setChildren(children - 1);
                          }
                        }}
                      >
                        -
                      </div>
                      <div
                        className="border-s-0 cursor-pointer border p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => setChildren(children + 1)}
                      >
                        +
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cursor-pointer rounded-md border-b p-2 hover:bg-gray-100">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4>Infants</h4>
                      <h6 className=" text-gray-400">0-23 Months</h6>
                    </div>
                    <h4>{infants}</h4>
                    <div className="flex items-center rounded-md border">
                      <div
                        className="cursor-pointer border border-r-0 p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => {
                          if (infants > 0) {
                            setInfants(infants - 1);
                          }
                        }}
                      >
                        -
                      </div>
                      <div
                        className="border-s-0 cursor-pointer border p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => setInfants(infants + 1)}
                      >
                        +
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex cursor-pointer items-center gap-2 rounded-md py-1 px-1 hover:bg-gray-100">
                    <input
                      type="radio"
                      id="economy"
                      name="flightType"
                      value="economy"
                      defaultChecked
                      onChange={handleFlightTypeChange}
                    />
                    <label htmlFor="economy" className="cursor-pointer">
                      Economy
                    </label>
                  </div>
                  <div className="flex cursor-pointer items-center gap-2 rounded-md py-1 px-1 hover:bg-gray-100">
                    <input
                      type="radio"
                      id="premiumEconomy"
                      name="flightType"
                      value="premium_economy"
                      onChange={handleFlightTypeChange}
                    />
                    <label htmlFor="premiumEconomy" className="cursor-pointer">
                      Premium Economy
                    </label>
                  </div>
                  <div className="flex cursor-pointer items-center gap-2 rounded-md py-1 px-1 hover:bg-gray-100">
                    <input
                      type="radio"
                      id="business"
                      name="flightType"
                      value="business"
                      onChange={handleFlightTypeChange}
                    />
                    <label htmlFor="business" className="cursor-pointer">
                      Business
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative mt-2 flex flex-wrap items-center justify-between">
          <div>
            <input
              className="mr-2 mt-2 cursor-pointer"
              type="checkbox"
              id="directFlight"
              name="directFlight"
              checked={directFlight}
              onChange={handleDirectflight}
            />
            <label htmlFor="directFlight" className="cursor-pointer">
              Direct Flight
            </label>
          </div>
          <div>
            <PhoneInputWithCountrySelect
              defaultCountry="CA"
              value={phoneNumber}
              onChange={(value) => setPhoneNumber(value)}
              placeholder="Enter Phone Number"
              className="w-full"
              inputClassName="h-10 w-full !bg-white !text-black px-2 text-lg focus:outline-none"
            />
          </div>
        </div>

        <div className="absolute bottom-[-35px] flex w-full justify-center">
          <button className="btn-grad" type="submit">
            SUBMIT
          </button>
        </div>
      </form>
      <div className="block sm:hidden">
        <OneWayForPhone />
      </div>
    </section>
  );
}
